<div class="p-grid" style="padding:20px;overflow-wrap: break-word;" >
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">ID</div>
        {{errorLogDetail?.id}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Logged</div>
        {{errorLogDetail?.logged}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Level</div>
        {{errorLogDetail?.level}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Machine Name</div>
        {{errorLogDetail?.machineName}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Message</div>
        {{errorLogDetail?.message}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Logger</div>
        {{errorLogDetail?.logger}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Properties</div>
        {{errorLogDetail?.properties}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Call Site</div>
        {{errorLogDetail?.callsite}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Exception</div>
        {{errorLogDetail?.exception}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold" >User Agent</div>
        {{errorLogDetail?.userAgent}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">IP Address</div>
        {{errorLogDetail?.ipAddress}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Request URL</div>
        {{errorLogDetail?.requestUrl}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Query String</div>
        {{errorLogDetail?.queryString}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">API Method</div>
        {{errorLogDetail?.apiMethod}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Posted Body</div>
        {{errorLogDetail?.postedBody}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Created By</div>
        {{errorLogDetail?.createdBy}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Created On</div>
        {{errorLogDetail?.createdOn}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Modified By</div>
        {{errorLogDetail?.modifiedBy}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Modified On</div>
        {{errorLogDetail?.modifiedOn}}
    </div>
    <div class="p-md-3 p-col-12">
        <div class="p-text-bold">Is Active</div>
        {{errorLogDetail?.isActive}}
    </div>
</div>